/**
 * Created by tofael on 7/13/17.
 */
import React from 'react';
import moment from 'moment';
import {connect} from 'react-redux';

import api from '../utility/api';
import utils from '../utility/utils';
import conf from '../utility/app-config';
import {getUser} from '../utility/local-storage';
import DoctorProfile from '../screens/profile';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';

const initialState = {
  profile: {
    id: '',
    name: '',
    email: '',
    phone: '',
    current_address_street: '',
    current_address_area: '',
    current_address_postcode: '',
    permanent_address_street: '',
    permanent_address_area: '',
    permanent_address_postcode: '',
    doc_reg_no: '',
    current_engagement: '',
    current_engagement_institute: '',
    credentials:'MBBS',
    passing_year: null,
    doctor_fee:{
      physical: undefined,
      remote: undefined
    },
    doctor_fee_within_week: {
      physical: undefined,
      remote: undefined
    },
    doctor_fee_within_month: {
      physical: undefined,
      remote: undefined
    },
    photo: '',
    operator:false,
    provider:false,
    user_id: null
  },
  fullscreen_image_url: '',
  imageViewerOpen: false,
  alertDialogOpen: false,
  action: '',
  alertLabel: '',
  scheduleDate: null,
  start_time: null,
  end_time: null,
  schedules: [],
  operatingHours: [],
  available_specialities: [],
  sip_id: '',
  sip_password: '',
  status: '',
  comment: '',
  sipDialogOpen: false,
  imagePreviewSrc: null,
  dialogData:null,
  locked: false
};
const doctorStatusOptions = [
  {value: 'pending', label: 'Pending'},
  {value: 'approved', label: 'Approved'},
  {value: 'rejected', label: 'Rejected'},
  {value: 'suspended', label: 'Suspended'}
];

const generateTimeSlot = (conf) => {
  let slots = [];
  let current = moment(conf.startTime);
  while (current <= conf.endTime) {
    let slot = new moment(current);
    slots.push(slot);
    current.add(conf.interval, 'minutes');
  }
  return slots;
}

const previewImageUrl = (file, cb)=> {
  const fileReader = new FileReader();
  fileReader.readAsDataURL(file);
  fileReader.onload = function (event) {
    cb(event.target.result);
  };
};

class Doctor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...initialState};

    this.onDoctorStatusChange = this.onDoctorStatusChange.bind(this);
  }

  componentDidMount() {
    this.getOperatingHour();
    this.getDoctorProfile();
    this.getAvailableSpecialities();
  }

  getOperatingHour(){
    api.getOperatingHour()
      .then((res)=>{
        let {startTime, endTime, interval} = res;
        let conf = {
          startTime: moment({hour: startTime.hour, minute: startTime.minute}),
          endTime: moment({hour: endTime.hour, minute: endTime.minute}),
          interval: interval //minutes
        };

        let operatingHours = generateTimeSlot(conf);
        this.setState({operatingHours});
      })
      .catch((e)=>{
        this.props.dispatch(showFeedback({message: 'Unable to fetch operating hours.'}))
      })
  }

  getAvailableSpecialities() {
    api.getSpecialities()
    .then((data) => {
      this.setState({available_specialities: data});
    })
  }

  onDoctorStatusChange(event, index, value) {
    this.setState({...this.state, status: value});
  }

  handleCommentChange(e) {
    this.setState({comment: e.target.value});
  }

  handleConfirmDialogClose() {
    this.setState({
      alertDialogOpen: false,
      action: '',
      alertLabel: '',
      dialogData:null
    });
  }

  handleConfirmDialogOpen(alertLabel, action, data) {
    this.setState({
      alertDialogOpen: true,
      action,
      alertLabel,
      dialogData:data
    });
  }

  setScheduleFormDate(date) {
    this.setState({
      scheduleDate: date
    });
  }

  onScheduleChange(field, event, value) {
    let newState = {};
    if (field === 'start_time') {
      newState.start_time = value;
      newState.end_time = null;
    } else {
      newState.end_time = value;
    }
    this.setState(newState);
  }

  handleSubmit(e) {

    e.preventDefault();

    let {provider, operator} = this.state.profile;

    if( !provider && !operator){
      this.props.dispatch(showFeedback({message: 'Please select a role.'}));
      return;
    }

    let doctorInfo = {};
    Object.assign(doctorInfo, this.state.profile);
    delete doctorInfo.photo;
    doctorInfo.status = this.state.status;

    this.props.dispatch(asyncStart());
    api.updateDoctorProfile(doctorInfo)
      .then(doctor => {
        let photo = this.state.profile.photo;
        if (photo && typeof photo === 'object') {
          let form_data = new FormData();
          form_data.append('photo', photo);
          form_data.append('id', doctor.id);
          return api.updateDoctorPhoto(form_data);
        }
        return doctor;
      })
      .then(doctor=>{
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: `Profile updated successfully.`}));
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      })

  }

  handleChange(field, e) {
    if(field === 'physical' || field === 'remote') {
      let profile = {
        ...this.state.profile,
      doctor_fee:{
        ...this.state.profile.doctor_fee,
        [field]: e.target.value
      }
    }
    this.setState({profile});
   }
    else if(field === 'physical_within_week') {
      let profile = {
        ...this.state.profile,
        doctor_fee_within_week:{
        ...this.state.profile.doctor_fee_within_week,
        physical: e.target.value
      }
    }
    this.setState({profile});
  }
     else if(field === 'remote_within_week') {
      let profile = {
        ...this.state.profile,
        doctor_fee_within_week:{
        ...this.state.profile.doctor_fee_within_week,
        remote: e.target.value
      }
    }
    this.setState({profile});
    }
    else if(field === 'physical_within_month') {
      let profile = {
        ...this.state.profile,
        doctor_fee_within_month:{
        ...this.state.profile.doctor_fee_within_month,
        physical: e.target.value
      }
    }
    this.setState({profile});
  }
  else if(field === 'remote_within_month') {
    let profile = {
      ...this.state.profile,
      doctor_fee_within_month:{
      ...this.state.profile.doctor_fee_within_month,
      remote: e.target.value
    }
  }
  this.setState({profile});
} else {
      let profile = {
        ...this.state.profile,
      [field]: e.target.value
      }
    this.setState({profile});
  }
}

  onCheck(field, e, value) {
    let profile = {
      ...this.state.profile,
      [field]: value
    };
    this.setState({profile});
  }

  onPhotoSelect(e) {
    let file = e.target.files[0];
    let profile = {
      ...this.state.profile,
      photo: file
    };

    previewImageUrl(file,(src)=>{
      this.setState({imagePreviewSrc: src});
    });

    this.setState({profile});
  }

  onSelectSpeciality(_, __, speciality) {
    let profile = {
      ...this.state.profile,
      speciality: speciality
    }
    this.setState({profile});
  }

  resendLogin() {
    this.props.dispatch(asyncStart());
    this.setState({alertDialogOpen: false})
    api.resetPassword(this.state.profile.user_id)
      .then(data => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: 'Password reset successful.'}));
      })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
        this.props.dispatch(asyncEnd());
      });
  }

  showImage(url, event) {
    this.setState({
      ...this.state,
      fullscreen_image_url: url,
      imageViewerOpen: true
    });
  }

  closeImage() {
    this.setState({
      ...this.state,
      fullscreen_image_url: '',
      imageViewerOpen: false
    });
  }

  handleSipCredsChange(field, e) {
    this.setState({[field]: e.target.value});
  }

  updateSipCredentials(e){
    e.preventDefault();

    let {sip_id, sip_password} = this.state;
    let {id: doctorId} = this.props.params;

    api.updateSipCredentials(doctorId, sip_id, sip_password)
      .then(data => {
        this.props.dispatch(showFeedback({message: "Sip credentials updated successfully."}));
        this.props.dispatch(asyncEnd());
        this.toggleSipDialog();
      })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
        this.props.dispatch(asyncEnd());
      });
  }

  submitStatusUpdate(e) {
    e.preventDefault();

    let {status, comment} = this.state;
    let {id: doctorId} = this.props.params;
    let adminUserId = getUser().id;
    this.props.dispatch(asyncStart());
    api.updateDoctorStatus(adminUserId, doctorId, status, comment)
      .then(data => {
        this.props.dispatch(showFeedback({message: "Status updated successfully."}));
        this.props.dispatch(asyncEnd());
      })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
        this.props.dispatch(asyncEnd());
      });
  }

  submitSchedule() {
    let {operatingHours} = this.state;

    let scheduleDateString = utils.toDate(this.state.scheduleDate);
    let startTimeString = utils.toAppTime(operatingHours[this.state.start_time]);
    let endTimeString = utils.toAppTime(operatingHours[this.state.end_time]);

    let start_time = moment(scheduleDateString + ' ' + startTimeString, 'MM/DD/YYYY h:mm a');
    let end_time = moment(scheduleDateString + ' ' + endTimeString, 'MM/DD/YYYY h:mm a');
    let {id: doctorId} = this.props.params;
    let body = {
      doctorId,
      start_time: start_time.toISOString(),
      end_time: end_time.toISOString()
    };

    this.props.dispatch(asyncStart());
    api.submitSchedule(body)
      .then(data => {
        this.props.dispatch(asyncEnd());
        let newSchedules = this.state.schedules.concat(data);
        this.setState({schedules: newSchedules, scheduleDate: null, start_time: null, end_time: null});
        this.props.dispatch(showFeedback({message: 'Doctor schedule created successfully'}));
      })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
        this.props.dispatch(asyncEnd());
      });
  }

  deleteSchedule() {
    this.setState({alertDialogOpen: false})
    let id = this.state.dialogData.scheduleId;
    this.props.dispatch(asyncStart());
    api.deleteSchedule(id)
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({
          schedules: this.state.schedules.filter((schedule, i) => schedule.id !== id)
        });
        this.props.dispatch(showFeedback({message: `Schedule deleted successfully`}));
      })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
        this.props.dispatch(asyncEnd());
      });
  }

  toggleSipDialog() {
   this.setState({sipDialogOpen: !this.state.sipDialogOpen});
  }

  getDoctorProfile(){
    this.props.dispatch(asyncStart());
    api.getDoctor(this.props.params.id)
      .then(resp => {
        this.props.dispatch(asyncEnd());
        let data = resp;
        this.setState({
          ...this.state,
          profile: {
            id: data.id,
            name: data.user.name,
            phone: data.user.phone,
            email: data.user.email,
            operator: data.user.operator,
            provider: data.user.provider,
            doc_reg_no: data.reg_no,
            photo: data.photo,
            current_engagement: data.current_engagement,
            current_engagement_institute: data.current_engagement_institute,
            user_id: data.user.id,
            current_address_street: data.current_address,
            current_address_area: data.current_area,
            current_address_postcode: data.current_postal_code,
            permanent_address_street: data.permanent_address,
            permanent_address_area: data.permanent_area,
            permanent_address_postcode: data.permanent_postal_code,
            passing_year: data.passing_year,
            doctor_fee: data.doctor_fee ? {
              physical: data.doctor_fee.physical,
              remote: data.doctor_fee.remote,
            } : {},
            doctor_fee_within_week: data.doctor_fee_within_week ? {
              physical: data.doctor_fee_within_week.physical,
              remote: data.doctor_fee_within_week.remote,
            } : {},
            doctor_fee_within_month: data.doctor_fee_within_month ? {
              physical: data.doctor_fee_within_month.physical,
              remote: data.doctor_fee_within_month.remote,
            } : {},
            passed_from: data.passed_from,
            credentials: data.credentials,
            speciality: data.speciality,
          },
          schedules: data.schedule,
          sip_id: data.sip_id,
          sip_password: data.sip_password,
          comment: data.comment,
          status: data.status,
          locked: data.user.locked,
          imagePreviewSrc: data.photo ? conf.urls.doc_url + data.photo : './images/user.jpg'
        });
      })
      .catch(error => {
        this.props.dispatch(showFeedback({message: error.message}));
        this.props.dispatch(asyncEnd());
      });
  }

  lockDoctor() {
    this.props.dispatch(asyncStart());
    this.setState({alertDialogOpen: false});
    api.lockUser(this.state.profile.user_id)
      .then(resp => {
        this.setState({locked: resp.locked})
        this.props.dispatch(showFeedback({message: 'User account locked.'}));
        this.props.dispatch(asyncEnd());
      })
      .catch(error => {
        alert(error.message);
        this.props.dispatch(asyncEnd());
      });

  };

  unlockDoctor() {
    this.props.dispatch(asyncStart());
    this.setState({alertDialogOpen: false});
    api.unlockUser(this.state.profile.user_id)
      .then(resp => {
        this.setState({locked: resp.locked});
        this.props.dispatch(showFeedback({message: 'User account unlocked.'}));
        this.props.dispatch(asyncEnd());
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
      });
  }

  render() {
    const getHandleConfirmFunction = () => {
      switch (this.state.action) {
        case 'reset-password' :
          return this.resendLogin.bind(this);
        case 'delete-schedule' :
          return this.deleteSchedule.bind(this);
        case 'lock' :
          return this.lockDoctor.bind(this);
        case 'unlock' :
          return this.unlockDoctor.bind(this);
        default : return () => {
          throw new Error(`Unhandled case: ${this.state.action}`);
        }
      }
    }

    return (
      <DoctorProfile
        isDoctor={true}
        title="Doctor Profile"
        fields={this.state.profile}
        startTime={this.state.start_time}
        endTime={this.state.end_time}
        schedules={this.state.schedules}
        available_specialities={this.state.available_specialities}
        scheduleDate={this.state.scheduleDate}
        statusOptions={doctorStatusOptions}
        onStatusChange={this.onDoctorStatusChange}
        submitStatusUpdate={this.submitStatusUpdate.bind(this)}
        handleCommentChange={this.handleCommentChange.bind(this)}
        resendLogin={this.resendLogin.bind(this)}
        showImage={this.showImage.bind(this)}
        showAlert={this.handleConfirmDialogOpen.bind(this)}
        onChange={this.onScheduleChange.bind(this)}
        setScheduleFormDate={this.setScheduleFormDate.bind(this)}
        operatingHours={this.state.operatingHours}
        submitSchedule={this.submitSchedule.bind(this)}
        deleteSchedule={this.deleteSchedule.bind(this)}
        closeImage={this.closeImage.bind(this)}
        imageViewerOpen={this.state.imageViewerOpen}
        imageUrl={this.state.fullscreen_image_url}
        alertDialogOpen={this.state.alertDialogOpen}
        alertText={this.state.alertLabel}
        handleConfirmDialogClose={this.handleConfirmDialogClose.bind(this)}
        getHandleConfirmFunction={getHandleConfirmFunction()}
        toggleSipDialog={this.toggleSipDialog.bind(this)}
        handleSipCredsChange={this.handleSipCredsChange.bind(this)}
        updateSipCredentials={this.updateSipCredentials.bind(this)}
        onCheck={this.onCheck.bind(this)}
        handleChange={this.handleChange.bind(this)}
        onSelectSpeciality={this.onSelectSpeciality.bind(this)}
        handleSubmit={this.handleSubmit.bind(this)}
        onPhotoSelect={this.onPhotoSelect.bind(this)}
        sipDialogOpen={this.state.sipDialogOpen}
        sipId={this.state.sip_id}
        sipPassword={this.state.sip_password}
        comment={this.state.comment}
        status={this.state.status}
        locked={this.state.locked}
        imagePreviewSrc={this.state.imagePreviewSrc}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(Doctor);



// WEBPACK FOOTER //
// ./src/containers/doctor-profile.js